import { connect } from 'react-redux'
import CourseInfo from '../components/CourseInfo'

const mapStateToProps = state => ({
  strings: state.intl.messages.courseInfo,
})

export default connect(mapStateToProps)(CourseInfo)
